module.exports = __webpack_public_path__ + "assets/img/app.6b3b6428.png";